export default "__VITE_ASSET__2c853259__"